// src/components/Navbar/DesktopNavLinks.jsx (Create this new file)
import React from 'react';
import { NavLink } from 'react-router-dom';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { styled } from '@mui/system'; // Needed for styled components from MUI

// --- THEME COLORS --- (You might want to import these from a central theme file later)
const colors = {
    textColor: '#ffffff',
    accentColor: '#19abf0',
};

// Define a styled Button if you want more custom base styles for all nav buttons
// For this example, we'll use sx prop on Mui Button directly for simplicity

const DesktopNavLinks = ({ menuCategories, handleClick }) => {
  return (
    // Use Box with responsive display settings
    // This Box will be a flex container for the buttons
    <Box
      sx={{
        display: { xs: 'none', md: 'flex' }, // Hide on mobile, show as flex on small screens and up
        flexGrow: 1, // Allows it to take up available space
        justifyContent: 'flex-end', // Aligns buttons to the right (away from the logo)
        alignItems: 'center', // Vertically centers buttons
        // Control spacing using 'gap' on larger screens.
        // On very large screens (lg), maybe more gap, less on md, auto on sm.
        // This prevents squishing.
        gap: { xs: 0, sm: '8px', md: '16px', lg: '24px' }, // Responsive gap
        minWidth: 0, // Prevents overflow issues in flex container if content is too wide
      }}
    >
      {menuCategories.map((item) => (
        <Button
          key={item.label}
          onClick={() => handleClick(item)}
          component={NavLink}
          to={item.url}
          sx={{
            color: colors.textColor,
            backgroundColor: '#000000', // Example background for button itself
            height: '3rem', // Fixed height
            minWidth: 'auto', // Allow buttons to shrink slightly if needed
            flexShrink: 1, // Prevents buttons from shrinking if text is long unless explicitly wrapped/hidden
            px: { xs: '0.5rem', sm: '0.8rem', md: '1rem' }, // Responsive horizontal padding
            py: '0.5rem', // Vertical padding
            margin: '0.25rem', // Small margin between buttons
            fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' }, // Responsive font size
            whiteSpace: 'nowrap', // Prevents text from wrapping within the button
            overflow: 'hidden', // Hides overflowing text
            textOverflow: 'ellipsis', // Adds "..." for overflowing text

            '&:hover': {
              color: colors.accentColor,
              backgroundColor: 'rgba(0,0,0,0.7)', // Slightly darker on hover
            },
            '&.active': {
              color: colors.accentColor,
              fontWeight: 'bold',
            },
          }}
        >
          {item.label}
        </Button>
      ))}
    </Box>
  );
};

export default DesktopNavLinks;